const ctaText = {
  saveTheDate: {
    title: 'One Step Closer to Beautiful Save the Dates',
    subtitle: `We’ll need a few details before you can send your save the dates. Don’t worry, you can update your details later if you need to. As a bonus, you also get a free wedding website!`
  },
  weddingInvites: {
    title: 'One Step Closer to Simple Invitations',
    subtitle: `We’ll need a few details before you can send invitations and RSVPs. Don’t worry, you can update your details later if you need to. As a bonus, you also get a free wedding website!`
  },
  weddingWebsite: {
    title: 'Start Building Your Wedding Website',
    subtitle: `We’ll need a few details first to build your website. Don’t worry, you can update your details later if you need to.`
  },
  guestList: {
    title: 'Start Building Your Smarter Guest List',
    subtitle: `We’ll need a few details first to start building your guest list and free wedding website. Don’t worry, you can update your details later if you need to.`
  },
  registry: {
    title: 'All Your Registries In One Place',
    subtitle: `We’ll need a few details first to build your registry and free wedding website. Don’t worry, you can update your details later if you need to.`
  },
  app: {
    title: 'An App For You And Your Guests',
    subtitle: `We’ll need a few details first to build your wedding app and website. Don’t worry, you can update your details later if you need to.`
  }
};

export const getCtaText = () => {
  const url = document.referrer;
  let referrerUrl = undefined;
  try {
    referrerUrl = new URL(url);
  } catch {
    referrerUrl = { pathname: '/' };
  }
  switch (true) {
    case RegExp('/save-the-date*').test(referrerUrl.pathname):
      return ctaText.saveTheDate;
    case RegExp('/wedding-website*').test(referrerUrl.pathname):
      return ctaText.weddingWebsite;
    case RegExp('/guest-list*').test(referrerUrl.pathname):
      return ctaText.guestList;
    case RegExp('/wedding-invitations*').test(referrerUrl.pathname):
      return ctaText.weddingInvites;
    case RegExp('/registry*').test(referrerUrl.pathname):
      return ctaText.registry;
    case RegExp('/app*').test(referrerUrl.pathname):
      return ctaText.app;
    default:
      return ctaText.weddingWebsite;
  }
};
